import { Avatar, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material'
import Iconify                                                            from '../ui/components/Iconify'
import { Link as RouterLink }                                             from 'react-router-dom'
import React                                                              from 'react'

export function DataRow({title, content, icon}) {
  return (<ListItem>
    {icon && <ListItemAvatar>
      <Avatar>
        <Iconify icon={icon} />
      </Avatar>
    </ListItemAvatar>}
    <ListItemText primary={content} secondary={title} />
  </ListItem>)
}
export function ClickableDataRow({title, content, href, icon, newTab = false}) {
  const linkProps = newTab ? {component: 'a', href, target: '_blank', rel: 'noopener noreferrer'} : {component: RouterLink, to: href}

  return (<ListItem>
    <ListItemButton sx={{ p: 0 }} {...linkProps}>
      {icon && <ListItemAvatar>
        <Avatar>
          <Iconify icon={icon} />
        </Avatar>
      </ListItemAvatar>}
      <ListItemText primary={content} secondary={title} />
    </ListItemButton>
  </ListItem>)
}
